import { render } from "./ArtrestorationView.vue?vue&type=template&id=705c9b01&scoped=true"
import script from "./ArtrestorationView.vue?vue&type=script&lang=js"
export * from "./ArtrestorationView.vue?vue&type=script&lang=js"

import "./ArtrestorationView.vue?vue&type=style&index=0&id=705c9b01&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705c9b01"]])

export default __exports__